// 历史记录
export default {
    playback: '历史回放',
    flyrecords: '飞行记录',
    flyplay: '飞行记录播放',
    video: '视频',
    photo: '照片',
    shoottime: '拍摄时段',
    min: '最小',
    max: '最大',
    select: "选择",
    manydowland: '批量下载',
    photosize: '图片大小',
    videosize: '视频时长',
    download: '下载',
    manydelophoto: '此操作将永久删除选中图片,是否继续',
    videoplay: '视频播放',
    delovideo: '此操作将永久删除此视频,是否继续',
    mustthree: '最多只能下载三个',
    manydelovideo: '此操作将永久删除选中视频,是否继续',
    tip_err1: '当前限制最多选择 99 个文件，本次选择了 {0} 个文件。',
    tip_err2: '图片格式错误，请重新上传!',
    tip_err3: '图片大小不能超过 10MB!',
}